import { FunctionComponent } from 'react'
import { Box, Alert, Button, Stack } from '@mui/material'
import { Sync as SyncIcon } from '@mui/icons-material'
import { useOfflineStatus } from '../hooks/useOfflineStatus'
import { useOfflineQueueProcessor } from '../hooks/useOfflineMutation'

interface NetworkStateProps {}

const NetworkState: FunctionComponent<NetworkStateProps> = () => {
  const { isOnline, queuedCount, isProcessing, lastSync } = useOfflineStatus()
  const { processQueue } = useOfflineQueueProcessor()

  const handleManualSync = async () => {
    try {
      await processQueue()
      console.log('Manual sync completed')
    } catch (error) {
      console.error('Manual sync failed:', error)
    }
  }

  const formatLastSync = (date: Date | null) => {
    if (!date) return ''
    const now = new Date()
    const diff = now.getTime() - date.getTime()
    const minutes = Math.floor(diff / (1000 * 60))

    if (minutes < 1) return 'przed chwilą'
    if (minutes < 60) return `${minutes} min temu`

    const hours = Math.floor(minutes / 60)
    if (hours < 24) return `${hours} godz. temu`

    const days = Math.floor(hours / 24)
    return `${days} dni temu`
  }

  return (
    <Box sx={{ px: 1.5 }}>
      <Stack spacing={0.5}>
        {(queuedCount > 0 || lastSync) && (
          <Alert
            severity={queuedCount > 0 ? 'warning' : 'info'}
            icon={isProcessing ? <SyncIcon className='rotating' /> : undefined}
            action={
              !isProcessing && (
                <Button
                  size='small'
                  onClick={handleManualSync}
                  sx={{
                    color: 'warning.main',
                    fontSize: '11px',
                    minWidth: 'auto',
                    px: 1
                  }}
                >
                  Sync ({queuedCount})
                </Button>
              )
            }
            sx={{
              '& .MuiAlert-message': { fontSize: '13px' },
              '& .MuiAlert-icon': { fontSize: '18px' }
            }}
          >
            {isProcessing
              ? 'Synchronizacja...'
              : queuedCount > 0
                ? !isOnline
                  ? `${queuedCount} operacji offline - zsynchronizuje się po powrocie połączenia`
                  : `${queuedCount} w kolejce`
                : lastSync
                  ? `Sync: ${formatLastSync(lastSync)}`
                  : 'Brak danych do synchronizacji'}
          </Alert>
        )}
      </Stack>

      <style>
        {`
          .rotating {
            animation: rotate 1s linear infinite;
          }
          
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  )
}

export default NetworkState
